export default __webpack_public_path__ + "static/media/science.7a90e0b4.png";